/*
  Sub category strip on collection pages (snippets/collection-subnav.liquid).

  - Mobile: stretches the scrolling row to the screen edges by measuring the
    space on each side (the same approach as facets-pill-bar.js, so the row
    can never be wider than the viewport), then scrolls the active item into
    view without moving the page.
  - The element is re-created from fetched HTML on every filter change, so
    all of the work happens in connectedCallback.
*/
class CollectionSubnav extends HTMLElement {
  constructor() {
    super();
    this.desktop = window.matchMedia('(min-width: 750px)');
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.layout();
    requestAnimationFrame(() => this.layout());
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.bleed();
  }

  get scroller() {
    return this.querySelector('.collection-subnav__list');
  }

  layout() {
    this.bleed();
    this.reveal();
  }

  bleed() {
    const scroller = this.scroller;
    if (!scroller) return;

    if (this.desktop.matches) {
      scroller.style.marginLeft = '';
      scroller.style.marginRight = '';
      scroller.style.paddingLeft = '';
      scroller.style.paddingRight = '';
      scroller.style.scrollPaddingLeft = '';
      return;
    }

    const rect = this.getBoundingClientRect();
    if (!rect.width) return;
    const viewportWidth = document.documentElement.clientWidth;
    const left = Math.max(0, Math.floor(rect.left));
    const right = Math.max(0, Math.floor(viewportWidth - rect.right));

    scroller.style.marginLeft = `-${left}px`;
    scroller.style.marginRight = `-${right}px`;
    scroller.style.paddingLeft = `${left}px`;
    scroller.style.paddingRight = `${right}px`;
    scroller.style.scrollPaddingLeft = `${left}px`;
  }

  /* Mobile: start the row with the active item near the left edge and a
     hint of the item before it, so the strip reads as "you are here". Done
     by setting scrollLeft (not scrollIntoView, which could also scroll the
     page vertically on load). */
  reveal() {
    const scroller = this.scroller;
    if (!scroller || this.desktop.matches) return;

    const active = scroller.querySelector('[aria-current]');
    if (!active) return;
    const item = active.closest('.collection-subnav__item') || active;
    const gutter = parseFloat(scroller.style.paddingLeft) || 0;
    const peek = 28;

    scroller.scrollLeft = Math.max(0, item.offsetLeft - gutter - peek);
  }
}

if (!customElements.get('collection-subnav')) {
  customElements.define('collection-subnav', CollectionSubnav);
}
